// Renderiza texto puro com URLs clicáveis (https://… ou www.…). Sem
// dangerouslySetInnerHTML — o texto continua texto (XSS-safe por construção);
// só os trechos que casam com URL viram <a>.
// stopPropagation no clique: a descrição vive dentro de cards que abrem modal,
// e tocar no link deve abrir o link, não o modal.

const URL_RE = /((?:https?:\/\/|www\.)[^\s<>()]+[^\s<>().,;:!?'"])/gi;

export function LinkifiedText({ text }: { text: string }) {
  const parts = text.split(URL_RE);
  if (parts.length === 1) return <>{text}</>;
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <a
            key={i}
            href={part.toLowerCase().startsWith("http") ? part : `https://${part}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline underline-offset-2 break-all"
            onClick={(e) => e.stopPropagation()}
          >
            {part}
          </a>
        ) : (
          <span key={i}>{part}</span>
        ),
      )}
    </>
  );
}
